import service from './Setting'



// export const CheckValidAddr = (obj) => service.post(`/Code/CheckAddr`, obj);
export const GetSystemParameters = () => service.get('/System/GetSystemParameters');
export const GetTowns = (obj) => service.get('/System/GetTowns',{params:obj});

export const GetCarBrands = () => service.get('/CarBrand/GetCarBrands');
export const GetCarModels = (obj) => service.get('/CarBrand/GetCarModels',{params:obj});
export const GetCarModelsByCarType = (obj) => service.get('/CarBrand/GetCarModelsByCarType',{params:obj});




//取得快速道路清單
export const GetExpressway = () => service.get('/Freeway/GetExpressway');
//取得高速公路清單
export const GetFreeway = () => service.get('/Freeway/GetFreeway');
export const GetFreewayRegionId = (obj) => service.post('/Freeway/GetFreewayRegionId',obj);
//取得快速道路縣市清單
export const GetExpresswayCountyList = () => service.get('/Freeway/GetExpresswayCountyList');

//取得快速道路清單
export const GetExpresswayByCountyCode = (coutyCode) => service.get(`/Freeway/GetExpresswayByCountyCode/${coutyCode}`);


//取得快速道路識別碼
export const GetExpresswayID = (obj) => service.post('/Freeway/GetExpresswayID',obj);


export const GetDivisionAndReststop = (val) => service.get(`/Freeway/GetDivisionAndReststop/${val}`);





